module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/Kutaniyaki-cde88234b1e965b87338f1777ec7ea54.jpg";